import { CloudProvisionerHeader } from "~/models/cloudprovisionertemplate/CloudProvisionerHeader";
import { SIMPLCloudEntity } from "../cloudtable/SimplCloudEntity";
import { useGetCloudProvisionerListWithPaginationQuery } from "~/services/cloudProvisioner";
import { useDeleteCloudEnvironmentsMutation } from "~/services/cloudenvironment";
import { DetailViewCloudProvisioner } from "./DetailsViewCloudProvisioner";
import { useTranslation } from "react-i18next";


export const SIMPLCloudProvisioner = () => {
  const { t } = useTranslation();
  return (
  <SIMPLCloudEntity
  title={t("CloudProvisioner")}
  loadingTitle={t("LoadingCloudProvisioners")}
  addLabel={t("AddNew")} 
  tableHeaders={CloudProvisionerHeader}
  fetchHook={useGetCloudProvisionerListWithPaginationQuery}
  deleteHook={useDeleteCloudEnvironmentsMutation}
  showButtonMoreActions={true}
  navigateAddRoute="/cloud-provisioner-template/add"
  navigateEditRoute="/cloud-provisioner-template/update"
  detailViewComponent={DetailViewCloudProvisioner}
  deleteTitle={t("DeleteCloudEnvironment")}
  showButtonDecommissionInModal={false}
  showButtonDownloadInModal={false}
  showConfigFileInModal={false}
   showButtonDeleteInModal={false}
  showButtonDetailsInModal={false}
  showEditInModal={false}
/>

  );
};
